import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Icon } from '@fiverr-private/fit';
import { r_check } from '@fiverr-private/icons';
import { VariationListings, Variation, hasCurvedText } from '@fiverr-private/variations_display';
import monitor, { EVENT_TYPES } from '../../../../service/bigquery';
import { useChooseVariationContext } from '../Context';
import './style.scss';

const Variations = ({ variations, className, isProjectOwner, brandName, slogan }) => {
    const { selectedVariation, setSelectedVariationId } = useChooseVariationContext();

    const handleSelect = (id) => {
        setSelectedVariationId(id);
        !isProjectOwner &&
            monitor.track(EVENT_TYPES.CHOOSE_VARIATION_CLICKED_ON_VARIATION, {
                makers_project: { variation: { id } },
            });
    };

    return (
        <div className={classnames('variations-container', className)}>
            <VariationListings
                variations={variations}
                wrapperClass="variations-grid"
                brandName={brandName}
                slogan={slogan}
                observeChanges={true}
                renderChild={(variation) => (
                    <div
                        key={variation.id}
                        className={classnames('grid-item', {
                            selected: variation.id === selectedVariation.id,
                        })}
                        onClick={() => handleSelect(variation.id)}
                    >
                        <Variation {...variation} applyVerticalChanges={!hasCurvedText(variation)} />
                        <div className="grid-item-frame">
                            <div className="grid-item-frame-checkmark">
                                <Icon color="#fff" size={8}>
                                    {r_check}
                                </Icon>
                            </div>
                        </div>
                    </div>
                )}
            />
        </div>
    );
};

Variations.propTypes = {
    variations: PropTypes.array,
    className: PropTypes.string,
    isProjectOwner: PropTypes.bool,
    brandName: PropTypes.string,
    slogan: PropTypes.string,
};

export default Variations;
